import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import "./case-email-interaction.css";
import { Table } from "@veneer/core";

interface CaseEmailInteractionProps {
  emailInteraction: any;
}

const CaseEmailInteraction: React.FC<CaseEmailInteractionProps> = ({ emailInteraction }) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {

    console.log(emailInteraction, 'emailInteraction')
    const formattedData: any = emailInteraction?.map((item: any) => ({
      Subject: item.Subject,
      From: item.From,
      To: item.To,
      EmailStatus: item.EmailStatus,
      ModifiedOn: item.ModifiedOn,
      CreatedOn: item.CreatedOn,
    }));

    setTableData(formattedData);
  }, []);

  const columns = [
    {
      id: "Subject",
      label: t("HPI.EditCase.Casedetails.Subject", {
        defaultValue: "Subject",
      }),
    },
    {
      id: "From",
      label: t("HPI.EditCase.Casedetails.From", {
        defaultValue: "From",
      }),
    },
    {
      id: "To",
      label: t("HPI.EditCase.Casedetails.To", {
        defaultValue: "To",
      }),
    },
    {
      id: "EmailStatus",
      label: t("HPI.EditCase.Casedetails.EmailStatus", {
        defaultValue: "Email Status",
      }),

    },
    {
      id: "ModifiedOn",
      label: t("HPI.EditCase.Casedetails.ModifiedOn", {
        defaultValue: "Modified On",
      }),
    },
    {
      id: "CreatedOn",
      label: t("HPI.EditCase.Casedetails.CreatedOn", {
        defaultValue: "Created On",
      }),
    }
  ];




  const renderCell = (value: string | undefined) => (value ? value : "N/A");

  return (
    <div className="case-information-summary">
      <h5 className="header-title">All Email Interaction</h5>
      <Container className="container-custom">
        {emailInteraction && emailInteraction.length > 0 ? (
          <Table
            columns={columns as any}
            data={tableData as any}
            loadingDataLength={5}
          />

        ) : (
          <p>No email interactions available.</p>
        )}
      </Container>
    </div>
  );
};

export default CaseEmailInteraction;
